import React from 'react'
import {HorizontalBar} from 'react-chartjs-2'

class Graph extends React.Component {
  render () {
    return(
      <div style={{height: '100%', width:'100%', maxheight:'350px', margin: 'auto'}}>
        <HorizontalBar
          data={{
            datasets: [{
              data: this.props.data,
              backgroundColor: ['rgba(75, 192, 192, 0.2)','rgba(54, 162, 235, 0.2)','rgba(255, 99, 132, 0.2)'],
              borderColor: ['rgba(75, 192, 192, 1)','rgba(54, 162, 235, 1)','rgba(255,99,132,1)'],
              borderWidth: 2,
            }],
            labels: ["Operational", "Service Due", "Maintenance Required"]
          }}
          options={{
            maintainAspectRatio:false,
            legend: {
              display: false,
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          }}
        />
      </div>
    )
  }
}

export default Graph;
